import React from 'react'
import {useStyles} from '@wix/tpa-settings/react'

import {stylesParams} from '../../stylesParams'
import {
  TimeSlotsListExtended as TimeSlotsListExtendedShared,
  TimeSlotsListExtendedProps,
} from '../../../../components-shared/TimeSlotsListExtended'

import {st, classes} from './TimeSlotsListExtended.st.css'

export const TimeSlotsListExtended: React.FC<
  Omit<TimeSlotsListExtendedProps, 'titleTag' | 'overdoneLinkClassName' | 'titleClassName'>
> = (props) => {
  const styles = useStyles()

  const titleTag =
    styles.get(stylesParams.generalSecondaryTitleFont).htmlTag ??
    styles.getDefaultValue(stylesParams.generalSecondaryTitleFont).htmlTag

  return (
    <TimeSlotsListExtendedShared
      {...props}
      overdoneLinkClassName={st(classes.overdoneLink)}
      titleClassName={st(classes.title)}
      titleTag={titleTag}
    />
  )
}
